<template>
  <div class="client-step-two_block">
    <div class="left">
      <h3 class="large_blue_label">2. マッチングしたオペレーターの確認。</h3>
      <p>条件に合致するオペレーターが見つかると、クライアントが登録したメールアドレス宛にオペレーターを紹介する通知を送ります。</p><br>
      <p>クライアントはそこで紹介されたオペレーターのプロフィールを確認し、発注希望を出すか、見送るか判断します。</p><br>
      <p>ここで紹介されたオペレーターには同じタイミングでクライアントの業務が紹介されており、<span class="marker-underline_label">双方が発注希望、受注希望を出せばマッチング成立となります。</span></p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/cl_five_steps_2.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ClientStepTwoBlock"
  }
</script>

<style lang="scss" scoped>
  .client-step-two_block {
    @include double_columns(40%, 35%);

    .large_blue_label {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>